<template>
  <div>
    <MasterMultipleAreaBase
      v-model="inputValue"
      :title="
        $t('common.common_product') +
        (editMode ? $t('common.common_edit') : $t('common.common_register'))
      "
      :width="width"
      :pageData="pageData"
      :productData="productData"
      @complete="complete()"
    >
      <template v-slot:[pageData[0].name]>
        <v-container fluid class="pa-0">
          <v-row no-gutters class="mx-10 my-3">
            <v-col cols="6">
              <InputFormNew
                v-model="inputData.productInfoLine1"
                :detail="items.productInfoLine1"
                :titleCols="inputFormStyle.titleCols"
                :contentsCols="inputFormStyle.contentsCols"
              >
                <template #supplier="{ item }">
                  <SelectSupplierName v-model="item.supplierId" />
                </template>
                <template #productCategory="{ item }">
                  <SelectProductCategory
                    v-model="item.categoryId"
                    :selectCategory="
                      setSelectCategoryName(
                        item.categoryId,
                        getProductCategoryFromState()
                      )
                    "
                  />
                </template>
                <!-- 税別小売金額 -->
                <template #taxExcludedRetailPrice="{ item }">
                  <v-row>
                    <v-col cols="7">
                      <v-text-field
                        v-model="item.taxExcludedRetailPrice"
                        :placeholder="$t('common.input_input_1')"
                        outlined
                        dense
                        hide-details
                      >
                      </v-text-field>
                    </v-col>
                    <v-col>
                      <SelectCurrency
                        v-model="item.taxExcludedRetailPriceCurrency"
                      />
                    </v-col>
                  </v-row>
                </template>
                <!-- 仕入価格 -->
                <template #purchasePrice="{ item }">
                  <v-row>
                    <v-col cols="7">
                      <v-text-field
                        v-model="item.purchasePrice"
                        :placeholder="$t('common.input_input_1')"
                        outlined
                        dense
                        hide-details
                      >
                      </v-text-field>
                    </v-col>
                    <v-col>
                      <SelectCurrency v-model="item.purchasePriceCurrency" />
                    </v-col>
                  </v-row>
                </template>
                <template #tax="{ item }">
                  <v-select
                    v-model="item.taxId"
                    item-text="taxRate"
                    item-value="consumptionTaxId"
                    :items="getTaxRateListFromState()"
                    dense
                    outlined
                    class="original-selectbox"
                    height="32px"
                    hide-details
                    :placeholder="$t('common.input_unselected_2')"
                  >
                  </v-select>
                </template>
              </InputFormNew>
            </v-col>
            <v-col cols="6">
              <InputFormNew
                v-model="inputData.productInfoLine2"
                :detail="items.productInfoLine2"
                :titleCols="3"
                :contentsCols="inputFormStyle.contentsCols"
              >
                <template #alertPeriod="{ item }">
                  <v-row align="center">
                    <v-col cols="9">
                      <v-text-field
                        v-model="item.alertPeriod"
                        placeholder="0"
                        outlined
                        dense
                        hide-details
                      />
                    </v-col>
                    <v-col cols="2" class="pa-0">{{
                      $t('product.product_days')
                    }}</v-col>
                  </v-row>
                </template>
                <template #isEnabled="{ item }">
                  <v-row>
                    <v-checkbox
                      v-model="item.isEnabled"
                      :label="$t('product.product_indicate')"
                    ></v-checkbox>
                  </v-row>
                </template>
                <template #isEnabledPenguin="{ item }">
                  <v-row>
                    <v-checkbox
                      v-model="item.isEnabledPenguin"
                      :label="$t('product.product_link-with-penguin-check')"
                    ></v-checkbox>
                  </v-row>
                </template>
              </InputFormNew>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:[pageData[1].name]>
        <v-container fluid class="pa-0">
          <v-row no-gutters class="mx-10 my-3">
            <v-col cols="6">
              <InputFormNew
                v-model="inputData.productDetailInfoLine1"
                :detail="items.productDetailInfoLine1"
                :titleCols="inputFormStyle.titleCols"
                :contentsCols="inputFormStyle.contentsCols"
              >
                <template #productImg="{ item }">
                  <div>
                    <input
                      style="display: none"
                      @change="formatSelectedFile(item.productImg)"
                      ref="input"
                      type="file"
                      name="file"
                    />
                    <div v-if="item.productImg" style="position: relative">
                      <v-img
                        height="80px"
                        width="80px"
                        :src="item.productImg"
                        @click="triggerFormatSelectedFile"
                      />
                      <div style="position: absolute; left: 0px; top: 0px">
                        <v-btn
                          width="10px"
                          height="10px"
                          icon
                          @click="deleteImg()"
                        >
                          <v-icon>mdi-close </v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <div v-else>
                      <v-img
                        :src="require('@/assets/icon_product_default@2x.png')"
                        height="80px"
                        width="80px"
                        @click="triggerFormatSelectedFile"
                      />
                    </div>
                  </div>
                </template>
                <template #makerName="{ item }">
                  <v-combobox
                    v-model="item.makerName"
                    :items="getMakerNameList()"
                    :placeholder="$t('common.input_input_1')"
                    append-icon=""
                    outlined
                    dense
                    hide-details
                  ></v-combobox>
                </template>
                <template #brandName="{ item }">
                  <v-combobox
                    v-model="item.brandName"
                    :items="getBrandNameList()"
                    :placeholder="$t('common.input_input_1')"
                    append-icon=""
                    outlined
                    dense
                    hide-details
                  ></v-combobox>
                </template>
                <template #productSize="{ item }">
                  <v-row align="center">
                    <v-col class="pr-0">W:</v-col>
                    <v-col cols="3" class="pl-1">
                      <v-text-field
                        v-model="item.productWidth"
                        placeholder="0cm"
                        outlined
                        dense
                        hide-details
                      />
                    </v-col>
                    <v-col class="pr-0">H:</v-col>
                    <v-col cols="3" class="pl-1">
                      <v-text-field
                        v-model="item.productHeight"
                        placeholder="0cm"
                        outlined
                        dense
                        hide-details
                      />
                    </v-col>
                    <v-col class="pr-0">D:</v-col>
                    <v-col cols="3" class="pl-1">
                      <v-text-field
                        v-model="item.productDepth"
                        placeholder="0cm"
                        outlined
                        dense
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </template>
                <template #packageSize="{ item }">
                  <v-row align="center">
                    <v-col class="pr-0">W:</v-col>
                    <v-col cols="3" class="pl-1">
                      <v-text-field
                        v-model="item.packageWidth"
                        placeholder="0cm"
                        outlined
                        dense
                        hide-details
                      />
                    </v-col>
                    <v-col class="pr-0">H:</v-col>
                    <v-col cols="3" class="pl-1">
                      <v-text-field
                        v-model="item.packageHeight"
                        placeholder="0cm"
                        outlined
                        dense
                        hide-details
                      />
                    </v-col>
                    <v-col class="pr-0">D:</v-col>
                    <v-col cols="3" class="pl-1">
                      <v-text-field
                        v-model="item.packageDepth"
                        placeholder="0cm"
                        outlined
                        dense
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </template>
              </InputFormNew>
            </v-col>
            <v-col cols="6">
              <InputFormNew
                v-model="inputData.productDetailInfoLine2"
                :detail="items.productDetailInfoLine2"
                :titleCols="inputFormStyle.titleCols"
                :contentsCols="inputFormStyle.contentsCols"
              >
                <template #bodyCopyJp="{ item }">
                  <v-textarea
                    outlined
                    v-model="item.bodyCopyJp"
                    rows="3"
                    :placeholder="$t('common.input_input_1')"
                    hide-details
                  ></v-textarea>
                </template>
                <template #bodyCopyCn="{ item }">
                  <v-textarea
                    outlined
                    v-model="item.bodyCopyCn"
                    rows="3"
                    :placeholder="$t('common.input_input_1')"
                    hide-details
                  ></v-textarea>
                </template>
                <template #approvalAcquisition="{ item }">
                  <v-textarea
                    outlined
                    v-model="item.approvalAcquisition"
                    rows="3"
                    :placeholder="$t('common.input_input_1')"
                    hide-details
                  ></v-textarea>
                </template>
                <template #component="{ item }">
                  <v-textarea
                    outlined
                    v-model="item.component"
                    rows="3"
                    :placeholder="$t('common.input_input_1')"
                    hide-details
                  ></v-textarea>
                </template>
              </InputFormNew>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </MasterMultipleAreaBase>
  </div>
</template>
<script>
import MasterMultipleAreaBase from '../MasterMultipleAreaBase'
import { InputFormNew } from '@/components/items'
import { mapActions, mapGetters } from 'vuex'
import _cloneDeep from 'lodash/cloneDeep'
import { supplierUtil } from '@/util'
import {
  SelectSupplierName,
  SelectProductCategory,
  SelectCurrency
} from '@/components/items/Selectboxes'

export default {
  components: {
    MasterMultipleAreaBase,
    InputFormNew,
    SelectSupplierName,
    SelectProductCategory,
    SelectCurrency
  },
  props: {
    value: { default: false },
    width: { default: '1166px' },
    productData: {
      type: Object,
      require: false,
      default: () => ({})
    },
    editMode: {
      type: Boolean,
      require: false,
      default: false
    }
  },
  data: () => ({
    uploadFile: null,
    fileInfo: null,
    inputFormStyle: {
      titleCols: 4,
      contentsCols: 7,
      inputItemHeight: '32px'
    },
    inputData: {},
    pageData: [
      {
        title: 'product.product_product-basic-info',
        name: 'productInfo',
        items: [],
        itemKey: ''
      },
      {
        title: 'product.product_product-details',
        name: 'productDetailInfo',
        items: [],
        itemKey: ''
      }
    ],
    items: {
      productInfoLine1: [
        {
          name: 'productNumber',
          text: 'product.product_product-number',
          required: true
        },
        {
          name: 'supplier',
          text: 'product.product_supplier',
          required: true
        },
        {
          name: 'productCategory',
          text: 'product.product_category',
          required: true
        },
        {
          name: 'productNameJp',
          text: 'product.product_product-name-japanese',
          required: true
        },
        {
          name: 'productNameCn',
          text: 'product.product_product-name-chinese',
          required: false
        },
        {
          name: 'taxExcludedRetailPrice',
          text: 'product.product_retail-price-excluding-tax',
          required: true
        },
        {
          name: 'purchasePrice',
          text: 'product.product_purchase-price',
          required: true,
          component: 'SelectCurrency'
        },
        {
          name: 'tax',
          text: 'common.product_consumption-tax-rate',
          required: true,
          cols: Math.ceil(3)
        }
      ],
      productInfoLine2: [
        {
          name: 'gtinCode',
          text: 'product.product_gtin-code',
          cols: Math.ceil(5),
          placeholder: '0000000000000'
        },
        {
          name: 'janCode',
          text: 'product.product_jan-code',
          cols: Math.ceil(5),
          placeholder: '0000000000000'
        },
        {
          name: 'lotQuantity',
          text: 'product.product_order-lot',
          required: true,
          cols: Math.ceil(2),
          placeholder: '0'
        },
        {
          name: 'capacity',
          text: 'common.product_capacity',
          cols: Math.ceil(2),
          placeholder: '0ml'
        },
        {
          name: 'weight',
          text: 'product.product_weight',
          cols: Math.ceil(2),
          placeholder: '0g'
        },
        {
          name: 'url',
          text: 'product.product_reference-url'
        },
        {
          name: 'alertPeriod',
          text: 'product.product_alert-period',
          cols: Math.ceil(3)
        },
        {
          name: 'isEnabled',
          text: 'product.product_display-setting',
          cols: Math.ceil(4)
        },
        {
          name: 'isEnabledPenguin',
          text: 'product.product_link-with-penguin',
          cols: Math.ceil(4)
        }
      ],
      productDetailInfoLine1: [
        {
          name: 'productImg',
          text: 'product.product_product-photo',
          cols: Math.ceil(3)
        },
        {
          name: 'makerName',
          text: 'product.product_manufacturer'
        },
        {
          name: 'brandName',
          text: 'product.product_brand'
        },
        {
          name: 'productSize',
          text: 'product.product_product-size'
        },
        {
          name: 'packageSize',
          text: 'product.product_outer-box-size'
        },
        {
          name: 'packageWeight',
          text: 'product.product_outer-box-weight',
          cols: Math.ceil(2),
          placeholder: '0g'
        },
        {
          name: 'cartonQuantity',
          text: 'product.product_carton-quantity',
          cols: Math.ceil(2),
          placeholder: '0'
        },
        {
          name: 'titleCopyJp',
          text: 'product.product_title-copy-japanese'
        },
        {
          name: 'titleCopyCn',
          text: 'product.product_title-copy-chinese'
        }
      ],
      productDetailInfoLine2: [
        {
          name: 'catchCopyJp',
          text: 'product.product_catch-copy-japanese'
        },
        {
          name: 'catchCopyCn',
          text: 'product.product_catch-copy-chinese'
        },
        {
          name: 'bodyCopyJp',
          text: 'product.product_body-copy-japanese',
          textPositionStart: true
        },
        {
          name: 'bodyCopyCn',
          text: 'product.product_body-copy-chinese',
          textPositionStart: true
        },
        {
          name: 'approvalAcquisition',
          text: 'product.product_about-acquisition-of-approval',
          textPositionStart: true
        },
        {
          name: 'component',
          text: 'product.product_ingredients-etc',
          textPositionStart: true
        }
      ]
    }
  }),

  created() {
    this.init()
  },

  methods: {
    ...mapActions('Common', ['getBrandListFromApi']),
    ...mapGetters('Common', [
      'getTaxRateListFromState',
      'getCountryCallingCodeJpFromState',
      'getCountryJpFromState',
      'getCurrencyJpFromState',
      'getBrandListFromState',
      'getProductCategoryFromState'
    ]),
    ...mapActions('Product', [
      'registerProduct',
      'editProduct',
      'getMakerListFromApi'
    ]),
    ...mapGetters('Product', ['getMakerListFromState']),
    ...mapActions('FileStore', ['fileUpload']),
    ...mapGetters('User', ['isSalonAccount', 'isMakerAccount']),

    // メーカーテーブルの配列から makerIdに合致するカラムのmakerNameを返す
    async getMakerNameFrom(productMakerId) {
      await this.getMakerListFromApi()
      const maker = this.getMakerListFromState()
        ? this.getMakerListFromState().find(
            (element) => element.makerId === productMakerId
          )
        : null
      if (maker) {
        return maker.name
      } else {
        return ''
      }
    },
    getMakerNameList() {
      const makerNameList = this.getMakerListFromState().map((obj) => obj.name)
      return makerNameList
    },
    // ブランドテーブルの配列からbrandIdに合致するinputNameを取得するメソッド
    async getBrandNameFrom(productBrandId) {
      await this.getBrandListFromApi()
      const brand = this.getBrandListFromState()
        ? this.getBrandListFromState().find(
            (element) => element.brandId === productBrandId
          )
        : null
      if (brand) {
        return brand.inputName
      } else {
        return ''
      }
    },
    getBrandNameList() {
      const brandNameList = this.getBrandListFromState().map(
        (obj) => obj.inputName
      )
      return brandNameList
    },
    setSelectCategoryName(categoryId, productCategoryList) {
      for (let productCategory of productCategoryList) {
        if (productCategory.productCategoryId === categoryId) {
          return productCategory.name
        }
        if (productCategory.childProductCategoryList) {
          const productCategoryName = this.setSelectCategoryName(
            categoryId,
            productCategory.childProductCategoryList
          )
          if (productCategoryName) {
            return productCategoryName
          }
        }
      }
      return null
    },

    async init() {
      this.initForm()
      supplierUtil.getSupplier(1) // 非表示設定の仕入先を除外して取得
      const formatData = _cloneDeep(this.productData)
      // 新規登録の際に「表示する」項目のダイアログ初期値をtrueで設定
      if (!Object.keys(formatData).length) {
        formatData.isEnabled = true
      }
      ;[formatData.makerName, formatData.brandName] = await Promise.all([
        this.getMakerNameFrom(this.productData.makerId),
        this.getBrandNameFrom(this.productData.brandId)
      ])

      this.inputData = {
        productId: formatData.productId,
        productInfoLine1: {
          productNumber: formatData.productNumber,
          supplierId: { value: formatData.supplierId },
          categoryId: formatData.categoryId,
          productNameJp: formatData.nameJp,
          productNameCn: formatData.nameCn,
          taxExcludedRetailPrice: formatData.taxExcludedRetailPrice,
          taxExcludedRetailPriceCurrency: {
            value: formatData.taxExcludedRetailPriceCurrencyId
              ? formatData.taxExcludedRetailPriceCurrencyId
              : this.getCurrencyJpFromState().value
          },
          purchasePrice: formatData.purchasePrice,
          purchasePriceCurrency: {
            value: formatData.purchasePriceCurrencyId
              ? formatData.purchasePriceCurrencyId
              : this.getCurrencyJpFromState().value
          },
          //消費税の初期値10%  "consumptionTaxId": 2,"taxRate": "10%"
          taxId: formatData.taxId ? formatData.taxId : 2
        },
        productInfoLine2: {
          gtinCode: formatData.gtinCode,
          janCode: formatData.janCode,
          lotQuantity: formatData.lotQuantity,
          capacity: formatData.capacity,
          weight: formatData.weight,
          url: formatData.url,
          alertPeriod: formatData.alertPeriod,
          isEnabled: formatData.isEnabled,
          isEnabledPenguin: formatData.isEnabledPenguin
        },
        productDetailInfoLine1: {
          productImg: formatData.productImg,
          makerName: formatData.makerName,
          brandName: formatData.brandName,
          productWidth: formatData.productWidth,
          productHeight: formatData.productHeight,
          productDepth: formatData.productDepth,
          packageWidth: formatData.packageWidth,
          packageHeight: formatData.packageHeight,
          packageDepth: formatData.packageDepth,
          packageWeight: formatData.packageWeight,
          cartonQuantity: formatData.cartonQuantity,
          titleCopyJp: formatData.titleCopyJp,
          titleCopyCn: formatData.titleCopyCn
        },
        productDetailInfoLine2: {
          catchCopyJp: formatData.catchCopyJp,
          catchCopyCn: formatData.catchCopyCn,
          bodyCopyJp: formatData.bodyCopyJp,
          bodyCopyCn: formatData.bodyCopyCn,
          approvalAcquisition: formatData.approvalAcquisition,
          component: formatData.component
        }
      }
    },
    initForm() {
      if (!this.isMakerAccount()) {
        let productInfoLine2 = this.items.productInfoLine2
        if (!this.isMakerAccount()) {
          productInfoLine2.splice(8, 1)
        }
        this.items.productInfoLine2 = productInfoLine2
      }
    },
    formatSelectedFile() {
      this.uploadFile = this.$refs.input.files[0]
      const uploadFileUrl = URL.createObjectURL(this.uploadFile)
      this.inputData.productDetailInfoLine1.productImg = uploadFileUrl
      this.$refs.input.value = ''
    },
    triggerFormatSelectedFile() {
      this.$refs.input.click()
    },
    deleteImg() {
      this.inputData.productDetailInfoLine1.productImg = ''
    },
    async complete() {
      // 画像アップロードAPI実行
      const formData = new FormData()
      if (this.uploadFile) {
        formData.append('uploadFile', this.uploadFile)
        const uploadData = await this.fileUpload(formData)
        this.inputData.productDetailInfoLine1.productImg = uploadData.data
      }
      const success = this.editMode
        ? await this.editProduct({
            productId: this.inputData.productId,
            params: this.inputData
          })
        : await this.registerProduct(this.inputData)

      if (success) {
        this.$emit('success')
      }
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },

  watch: {
    inputValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) this.init()
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
